import router from '../router'

router.beforeEach((to, from, next) => {
  let date = new Date()
  let time = date.getTime()
  /* 判断该路由是否需要登录权限 */
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let admin = JSON.parse(localStorage.getItem("adminInfo"));
    let created = admin!=null ? parseInt(admin.updated) : NaN
    let alive = admin!=null ? parseInt(admin.length) : NaN
    
    //是否登录
    if (admin == null || isNaN(created) || isNaN(alive) || ((created + alive) < time)) {
      next({
        path: '/manage/login',
        // query: {
        //   redirect: to.fullPath
        // }
      })
    } else {
      next()
    }
  } else {
    next();
  }

})